module.exports = __webpack_public_path__ + "static/media/ot_7.528ed133.JPG";